import type { CardAdf, CardAppearance } from '@atlaskit/smart-card';
import { EditorCardProvider } from '@atlaskit/smart-card';
import { parseIssueKeyFromUrl } from 'util/url';
import { origin } from 'util/location';
import { canViewRequest } from 'rest/smart-card';

export const getSmartCardUrl = (issueKey: string) => {
    return `${origin()}/browse/${issueKey}`;
};

export class PortalCardProvider extends EditorCardProvider {
    async resolve(url: string, appearance: CardAppearance): Promise<CardAdf> {
        const issueKey = parseIssueKeyFromUrl(url);
        if (issueKey === null) {
            return super.resolve(url, appearance);
        }

        return canViewRequest(issueKey).then((canViewRequestInPortal) => {
            if (canViewRequestInPortal) {
                return {
                    type: 'inlineCard',
                    attrs: {
                        url: getSmartCardUrl(issueKey),
                    },
                };
            }
            return Promise.reject();
        });
    }
}
